const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const createReviewCorrectiveActionMachine = ({
  correctiveAction,
  token,
  qmsToolApiUrl,
  reportId,
}) =>
  createMachine(
    {
      /** @xstate-layout N4IgpgJg5mDOIC5QCcwDcCWYDuBaAxgPbKr4AuGaYuAhuRoQHYB0kGFjUAxACICiAZQDCAJQCSABQAqYgPIA5APpCAEgEF5AcT48A2gAYAuolAAHQrHYNGJkAA9EuAIwBOACzMAbAFZ93gOwAzC6eTgAcbvoATFEANCAAnohO-v7M3mFhKZ5h3k5OblFhngC+JfGomDgExKQUVLT0TKwQVpxcAlJqUgCqAsrqWjoGxkgg5pYUTLYOCM5BzPpuYS4uxWFB3t6e8UkIgSnpa4GeMW4Fbt6BZRXoWHhEJGD0DXRTLGwc3D0SPN18I1sEys0zGsycUX0zCibk8bkC-kKgW8IRWu2Sbhc0MCYUhTj8kX8LmRNxAlXuNSeL2ob2sLTa3H4ABk+FIAUYgRYQTYwYhPEtmKkMvD-CsVpj0QgQosXL4CWF9Jk3P5vKTydVHnVKDSmh9Wl8uD8-mzFAAhPhqER8ESKKSyADSfHkgLGwPeM2SgSh-n0IScnkChVOorcktwGS853cTgOKOCITVdw1tWe9R173pBr4AA0JGIRN05EpjXxFAI+CyhGy9BzXVz3by5lEIcwVlEVT5Iv6InFEogUVF0oiXP4AwdXMtE1UHinqY0M58MO1BjwWTapABNCSl1QabQ10ZmevWD1zVyBZjKmL4zy35YbSWXDypIlObzwiK+-xTima1Pa+c6UXdp+AAMWtAsmUUK01AEBQBj3YZayPSYT0bXBm08ZgQk8EdvCiFx9G7QpJRVKEinHXCcQRa5yjJJMZypNNAOaABXUwIBoMgwGYdjOINCAmB4pc0EIABrHj1UYrVXl1XiOK4ni+K4pcoAQETCHwFSmBGF0UO5U8YgvaJAmbLsDgI-xSNhZhA3CVZ23yGNvzoqTKRk9M6WU7j5P41SuDAEhiGYUwABsuIAM2IABbZg3L-OdaTYhSfO81T1MYUStPeXTkPGY9QVAWZlkHGMVmifR+X0aJlUffxStSTFfHxQISVchj3P-WSM28njAuQYguCtKQRA3PT8tQwr7H7ZUvA2DIYk8IlYRcSVgkHW8FVFZalpcKIf2TJiAKSlhetYILkGYfAAAtnjEgACfriHusgElMMAuHGt00KKxAgjCdJ8IDFx8X9Srez2d8oWVK49v0UUrgyA7pK6zzkv4vqLqu278Aep7kBet6Pt0JxDwmgzGxCLEYgHXJ4RqsJJShy8VXhKI8jCUzcmRzrErks78eYOh8DgWB7ogMBGCwCAuCEDQhArL6Cp5X6ECCNIiKyLYiNOLJQz7NWckjOELiIhENh5hLmJO5gJdCsAfLth3-MExhhMy8TJI6q3jrkp3HbAe2vgyrLtMYXKye+qbwXfLD6qB-QEThXFSK9QVRUDPbzkyOFLdna2-cDh2eP9-zBbCyKYri73899jN-ZLovg407LrAjzlJpV6aEHCKILwRf0+8z0JojWgUcVhUzmyuaIXDzo7urpBvzoG5AhtZUalc7097MHWFb1OW9IV8HYDZp9JLlwunfUKNx548liWGXwWbrux6LsJ97PryqOu9mZt2atjcMsVYuF2ajisgbGitkAhLARNsBa99UaP1tk3TGq9sZv3xp-YmpMO4U1VjCaIzAIRLSvIROBa0FjIh9CKBBuIkF83rmglewVhai3FpLaWst5aKx-srQyiosSc2KKKVYrViT6z2LrQUAZwg3g7C5W405eYFx6ilSA39I4CPQlEI2pkQzVRhIPRmBtpQ3xCNVByCJE5lDoowQgEt4BjHirXReU1f6nlwAcLCBjPw1RMWGAoWECj2WCSqEcPhGFqKAvqVS+CGyq18K2eGOJiRvlvMEUckpciLFSHolYwRWoFFoso38bi0ZPzQRABJP1u5vh9LZM4rVgHjkDJKQiThoSYkRPhXu+Rol1y8ho2p0dkiIkFHtTY4RcRLUgXsPRHhJFFD0VcTmRJVTtRUT7dxp0NG+RUpwUZf9EAxEHESdsyIZl6NSGtfCl5Aw+MRitAMgzdkHJ8vjY5p4loAy2Ho4IoN+SnDWoRS8uRRwwioqcf0bzKkfPQcFV+uN36rxwd8xs9U0ghDMntbW4Q6rYohSEZEvpiQRDhSggWWN2GwDFhLKWkAMWq3qlhf5wMgXg0lFVFmsNIQI2RGESlNtqUYNgIFKgBMvl1m3pTVI2ECiVVCFsfCKJuXVV5ZEQo+JlQnGFYXIOYBmX1JhthWEKQQYjnhCOSU+QPBembEEJa74KFKPotsipKDl6lyOTKgh9T8IXncKEV8VqsmSjxCkmI8Mtj+AhNkfVzDDWsOQMa-+8M0gRBAVTcBS0I191sgGVpsJ4Zm02WUw6D8bbPyxsivGH9XrvTTact8XTzY5B8COABUjEAHChMUCRJwITIjnls8pC94U1owbS+lXCmV+sSd3MyUIMipHxBEVqfhT57HhBefINV6rrThO+RNS8WGC3FcgSVqLiDNoQMY-tb5qqikTicPwj5WokPxH3cIfaOynvRopGpC66n-0-VsW+2tCIcx7VKYhmJj2ilvASTZZQgA */
      predictableActionArguments: true,
      id: "review-corrective-action",
      context: {
        changes: new Set(),
        correctiveAction: correctiveAction,
        authentication: { token: token },
        reportId: reportId,
        qmsToolApiUrl: qmsToolApiUrl,
      },

      states: {
        editing: {
          on: {
            DESCRIPTION_CHANGED: {
              target: "editing",
              internal: true,
              actions: ["saveDescription", "flagChanges"],
            },

            STATUS_CHANGED: {
              target: "editing",
              internal: true,
              actions: ["saveStatus", "flagChanges"],
            },

            UPDATE: {
              target: "update",
              cond: "validChangeSet",
            },

            DELETE: "delete",

            UPDATE_BEARER_TOKEN: {
              target: "editing",
              internal: true,
              cond: "validToken",
              actions: "saveToken",
            },

            EXPIRATION_DATE_SELECTED: {
              target: "editing",
              internal: true,
              actions: [
                "saveExpirationDate",
                "flagChanges",
                "flagDeferralReasonAsMandatory",
              ],
            },

            HANDLER_TYPE_CHANGED: {
              target: "editing",
              internal: true,
              actions: ["saveHandlerType", "flagChanges"],
            },

            DEFERRAL_REASON_CHANGED: {
              target: "editing",
              internal: true,
              actions: ["saveDeferralReason", "flagChanges"],
            },
          },
        },

        deleted: {
          type: "final",
          entry: "sendDeleteEventToParent",
        },

        update: {
          states: {
            updating: {
              invoke: {
                src: "updateCorrectiveAction",
                onDone: {
                  target: "#review-corrective-action.updated",
                  actions: [
                    "unflagChanges",
                    "emptyChanges",
                    "unflagDeferralReasonAsMandatory",
                  ],
                },
                onError: {
                  target: "error",
                  actions: "saveError",
                },
              },
            },

            error: {
              on: {
                RETRY: "updating",
              },

              states: {
                "check error type": {
                  always: [
                    {
                      target: "access denied",
                      cond: "accessDeniedError",
                    },
                    "server error",
                  ],
                },

                "access denied": {
                  on: {
                    CANCEL: "#review-corrective-action.editing",
                  },
                },
                "server error": {},
              },

              initial: "check error type",
            },
          },

          initial: "updating",
        },

        delete: {
          states: {
            deleting: {
              invoke: {
                src: "deleteCorrectiveAction",
                onDone: "#review-corrective-action.deleted",
                onError: {
                  target: "error",
                  actions: "saveError",
                },
              },
            },

            error: {
              on: {
                RETRY: "deleting",
              },

              states: {
                "check error type": {
                  always: [
                    {
                      target: "access denied",
                      cond: "accessDeniedError",
                    },
                    "server error",
                  ],
                },

                "access denied": {
                  on: {
                    CANCEL: "#review-corrective-action.editing",
                  },
                },
                "server error": {},
              },

              initial: "check error type",
            },
          },

          initial: "deleting",
        },
        updated: {
          entry: "sendUpdateEventToParent",

          always: "editing",
        },
      },

      initial: "editing",
    },
    {
      actions: actions,
      guards: guards,
      services: services,
    },
  );

export { createReviewCorrectiveActionMachine };
